import React, { FC, useState } from "react";
import { Button, DatePicker, DatePickerProps } from "@xapp/components";
import { DateRange } from 'react-day-picker';
import { format } from 'date-fns';
import styles from "./styles.scss"

type DateBefore = {
    before: Date;
};

type DateAfter = {
    after: Date;
};

type DateInterval = {
    before: Date;
    after: Date;
};

type DayOfWeek = {
    dayOfWeek: number[];
};

type Matcher = boolean | Date | DateRange | ((date: Date) => boolean) | Date[] | DateBefore | DateAfter | DateInterval | DayOfWeek

export interface DatePickerWrapperProps extends DatePickerProps {
    title?: string;
    dateValue?: string;
    disabled?: Matcher | Matcher[];
    onSubmitDate?: (start: Date, end: Date) => void;
}

export const DatePickerWrapper: FC<DatePickerWrapperProps> = ({ onSubmitDate, dateValue, title, disabled, ...props }) => {

    const { min, max } = props

    const currentDate = new Date();

    const defaultSelected: DateRange = {
        from: undefined,
        to: undefined
    };

    const [range, setRange] = useState<DateRange | undefined>(defaultSelected);
    const [calendar, setCalendar] = useState<boolean>(false);

    const openCalendar = () => {
        setCalendar(true)
    };

    const handleResetClick = () => setRange(defaultSelected);

    const handleDateSubmit = () => {
        if (range && range.from && range.to) {
            onSubmitDate(range.from, range.to);
        }
    };

    let footer = <p style={{ margin: "10px" }}>Please pick the first day.</p>;
    if (range?.from) {
        if (!range.to) {
            footer = <p>{format(range.from, 'yyyy/MM/dd')}</p>;
        } else if (range.to) {
            footer = (
                <>
                    <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                        <div>
                            <p style={{ textAlign: "center" }}>
                                {format(range.from, 'yyyy/MM/dd')} {format(range.to, 'yyyy/MM/dd')}
                            </p>
                        </div>
                        <div style={{ display: "flex" }}>
                            <Button className={styles.buttons} label='Ok' variation="primary" onClick={() => { handleDateSubmit(); setCalendar(false) }} />
                            <Button className={styles.buttons} label='Reset' variation="secondary" onClick={handleResetClick} />
                        </div>
                    </div>
                    {min && max && <p style={{ fontSize: "12px", margin: "10px" }}>{`You can choose a minimum range of ${min} days and a maximum of ${max} days`}</p>}
                </>
            );
        }
    }

    return (
        <>
            <DatePicker
                title={title}
                mode="range"
                footer={footer}
                defaultMonth={currentDate}
                selected={range}
                openCalendar={calendar}
                dateValue={dateValue}
                disabled={disabled}
                onSelect={setRange}
                onCalendar={openCalendar} />
        </>
    )
}